import twemoji from 'twemoji'

export function emoji (character) {
  return twemoji.parse(character)
}
